// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LocationPage_Wrapper__3jLB8","Container":"LocationPage_Container__1Zqx1"};